import { PriceParser as BcomPriceParser } from '@common-vue/media-card-large/src/modules/price/components/bcom';
import { PriceParser as McomPriceParser } from '@common-vue/media-card-large/src/modules/price/components';

import { useBrand } from '@composables/useBrand';
import { useKillswitches, useFeatureEligibility } from '@modules/featureControl';

function getKillswitches() {
  const { killswitches } = useKillswitches();
  const {
    isConsolidatedPhase3Enabled,
    isColorwayPromosEnabled,
    ccfpEnabled,
    klarnaPaymentEnabled,
    isConsolidatedMasterPageEnabled,
    isBigTicketHideInStockOfferFeatureEnabled,
    isUpcLevelPromoBadgingEnabled,
  } = killswitches;

  return {
    isConsolidatedPhase3Enabled,
    isColorwayPromosEnabled,
    ccfpEnabled,
    klarnaPaymentEnabled,
    isConsolidatedMasterPageEnabled,
    isBigTicketHideInStockOfferFeatureEnabled,
    isUpcLevelPromoBadgingEnabled,
  };
}

/**
 *  price parser parity between mcom / bcom
 * @param {Product} product
 * @returns {object}
 */
export function usePriceParser(product) {
  const { isMcom } = useBrand();
  const killswitches = getKillswitches();
  const priceOpts = { iShip: !!useFeatureEligibility()?.isInternationalMode };

  const priceParser = isMcom ? McomPriceParser : BcomPriceParser;

  return priceParser(product, killswitches, priceOpts);
}

export default usePriceParser;
